import { instance } from '../../util/http'
import apis from '../../config/apis'

// 是否满足条件
const getCheck = () => {
    return instance.get(apis.MerchantVerification.GetCheck)
}
// 获取用户表单信息
const get = () => {
    return instance.get(apis.MerchantVerification.Get)
}

// 插入表单
const post = (data) => {
    return instance.post(apis.MerchantVerification.Post,data)
 }

export default {
    getCheck,
    get,
    post
}